import _regeneratorRuntime from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var __default__ = {
  name: "MessageDetail",
  data: function data() {
    return {
      message: [],
      enquete: [],
      message_detail: {
        message: {
          message_scheduled_for: "",
          call_scheduled_for: ""
        },
        content: {},
        enquete: {
          implement_to: ""
        },
        enquete_contents: {}
      },
      getS3UrlStatus: "内容を確認",
      getS3UrlStatusRunning: false,
      message_targets_count: 0,
      message_targets_students_count: 0,
      message_targets_participants_count: 0,
      message_call_setting: "",
      isLoading: true,
      showConfirmModal: false
    };
  },
  head: {
    title: function title() {
      return {
        inner: "お知らせ配信履歴詳細"
      };
    }
  },
  computed: _objectSpread({}, mapState(["studentAddress"])),
  created: function created() {
    this.setData();
  },
  methods: {
    setData: function setData() {
      var _this = this;

      getData("reader/get_message_detail/" + this.$route.params.id).then(function (data) {
        _this.message_detail = data.items;
        _this.message_targets_count = data.items.targets.students.length + data.items.targets.participants.length;
        _this.message_targets_students_count = data.items.targets.students.length;
        _this.message_targets_participants_count = data.items.targets.participants.length;
        _this.message_detail.message.message_scheduled_for = moment(_this.message_detail.message.message_scheduled_for).format("YYYY年MM月DD日(ddd) HH:mm");
        _this.message_detail.message.call_scheduled_for = moment(_this.message_detail.message.call_scheduled_for).format("YYYY年MM月DD日(ddd) HH:mm");

        if (_this.message_detail.enquete) {
          _this.message_detail.enquete.implement_to = _this.message_detail.enquete ? moment(_this.message_detail.enquete.implement_to).format("YYYY年MM月DD日(ddd) HH:mm") : null;
        }

        var call_settings = JSON.parse(_this.message_detail.message.settings);
        console.log(call_settings);

        if (call_settings.auto_redial.use === true) {
          _this.message_call_setting = call_settings.auto_redial.interval + "分毎に最大" + call_settings.auto_redial.iteration + "回";
        } else {
          _this.message_call_setting = "なし";
        }
      }).catch(function (error) {
        console.log(error); // axiosのresponseが存在するエラーの時は一覧に戻る
        // if (error.response) {
        //   this.$router.push({ name: "messages" });
        // }
      }).then(function () {
        _this.isLoading = false;
      });
    },
    getS3SignedUrl: function getS3SignedUrl() {
      var _this2 = this;

      this.getS3UrlStatus = "お待ち下さい";
      this.getS3UrlStatusRunning = true; //secure browserのpopup block 対策

      var newWindow = window.open();
      getData("reader/get_s3_signed_url?path=" + encodeURIComponent(this.message_detail.message.attached_file)).then(function (data) {
        newWindow.location = data.items.s3url;
      }).catch(function (error) {
        console.log(error);
      }).then(function () {
        _this2.getS3UrlStatus = "内容を確認";
        _this2.getS3UrlStatusRunning = false;
      });
    },
    switchVisibility: function switchVisibility(input) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return updateData("messages/settings/" + _this3.$route.params.id, {
                  visibility: input
                });

              case 3:
                _this3.setData();

                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 6]]);
      }))();
    },
    showDisableConfirm: function showDisableConfirm() {
      this.showConfirmModal = true;
    },
    hideDisableConfirm: function hideDisableConfirm() {
      this.showConfirmModal = false;
    },
    executeDisableMessage: function executeDisableMessage() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.showConfirmModal = false;
                _context2.prev = 1;
                _context2.next = 4;
                return updateData("messages/expire/" + _this4.$route.params.id, {});

              case 4:
                _this4.setData();

                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](1);
                console.log(_context2.t0);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 7]]);
      }))();
    },
    disableMessage: function disableMessage() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return updateData("messages/expire/" + _this5.$route.params.id, {});

              case 3:
                _this5.setData();

                _context3.next = 9;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3["catch"](0);
                console.log(_context3.t0);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 6]]);
      }))();
    }
  }
};
import moment from "moment";
import { getData, updateData } from "@/services/axios";
import LoadingMessage from "@/components/common/LoadingMessage";
import UrlToLink from "@/components/common/UrlToLink.vue";
import RowItem from "../RowItem";
import ConfirmModal from "@/components/common/ConfirmModal.vue";
import { mapState } from "vuex";
export default /*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props) {
    return {
      __sfc: true,
      moment: moment,
      LoadingMessage: LoadingMessage,
      UrlToLink: UrlToLink,
      RowItem: RowItem,
      ConfirmModal: ConfirmModal
    };
  }
});